import React, { Fragment } from 'react';

export default ({ value, localParams }: any) => {
    const paramRegex = '{{.*?}}';
    const parts = value.split(new RegExp(`(${paramRegex})`, 'g')).filter((part: any) => !!part);

    if (parts.length === 1) {
        // No parameters in template string
        return value;
    }

    return parts.map((part: any) => {
        if (new RegExp(`^${paramRegex}$`).test(part)) {
            const param = part.replace(/{{|}}/g, '');

            if (!localParams[param]) {
                throw new Error(`Parameter ${param} has not been provided for template string: ${value}`);
            }

            return React.cloneElement(localParams[param], { key: param });
        }
        return <Fragment key={part}>{part}</Fragment>;
    });
};
